import Vue from 'vue'
import Vuex from 'vuex'
import {GroupPersistance, Selfie} from '@internal-projects/toolie-core/dist';
import router from './../router'

// Instanceiate 
let groupPersistance = new GroupPersistance();
let selfie = new Selfie();

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    settings: {
      excludeNames: false,
      showPickedNames: false,
      namepicker: 'slotmachine'
    },
    UIstate: {
      remoteForm: false,
      remoteActive: false,
      groupPersistance: false,
      menuOptions: {
        navicon: true,
        close: false,
        back: false,
        remote: true
      }
    },
    roster:[],
    shuffledNames: [],
    pickedNames:[],
    persistentGroups: [],
    nextToExclude: null
  },
  mutations: {
    configMenuUI(state, newState){
      state.UIstate.menuOptions = { ...state.UIstate.menuOptions, ...newState }
    },
    updateSettings(state, updatedSettings){
      state.settings = updatedSettings
    },
    updateRoster(state, roster){
      state.roster = roster.split('\n');
    },
    updatePersistentGroups(state, groups){
      state.persistentGroups = groups;
    },
    toggleGroupPersistance(state){
      state.UIstate.groupPersistance = !state.UIstate.groupPersistance;
    },
    setShuffledNames(state, nameList){
      state.shuffledNames = nameList;
    },
    updatePicked(state, name){
      setTimeout(() => {
        state.pickedNames.push(name);
      },500)
    },
    excludeName(state, id){
      if(state.settings.excludeNames && id !== null){
        let idx = state.shuffledNames.findIndex(person => person.id === id);
        state.shuffledNames.splice(idx, 1);       
      }
    },
    toggleRemoteForm(state){
      state.UIstate.remoteForm = !state.UIstate.remoteForm;
    }
  },
  actions: {
    async submit({state, commit}, reset){
      if(!reset){ // no reroute on reset
        router.push(`/namepickers/${state.settings.namepicker}`);
      }

      let nameList = selfie.shuffle(state.roster); // adds ids

      state.pickedNames = []; // reset
      commit('setShuffledNames', nameList);
    },

    async readPersistentGroups({ commit }){ 
      const groups = groupPersistance.read();
      if(groups){
        commit('updatePersistentGroups', groups);
      } else {
        commit('updatePersistentGroups', []);
      }
    },

    async savePersistentGroup({ dispatch, state }, newGroup){
      groupPersistance.create(state.roster, newGroup.name);    
      await dispatch('readPersistentGroups');
    },

    async deletePersistentGroup({ dispatch }, groupId){
      groupPersistance.delete(groupId);
      await dispatch('readPersistentGroups');
    },

    async connectRemote(_,room){
      console.log('Connecting to ' + room)
    }
  }
})
